module.exports = __webpack_public_path__ + "static/media/galerija_2013 (24).6fdbafeb.jpg";